module.exports = __webpack_public_path__ + "static/media/info_icn.dff93a66.svg";